module.exports = __webpack_public_path__ + "images/sovcom-ed74f530.png";